import validate from 'validate.js'

const constraints = {
  topicId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
